import {
  AOPMaltaAdmissionData,
  AOPMaltaInvoiceData,
  AOPMaltaAcknowledgementData,
  AOPMaltaPaymentConfirmationData,
  AOPMaltaStudentData,
  AOPMaltaCertificateData,
  ///////////////////////
  AOPPolandAdmissionData,
  AOPPolandInvoiceData,
  AOPPolandPaymentConfirmationData,
  AOPPolandAcknowledgementData,
  ///////////////////////
  AOPUkraineAdmissionData,
  AOPUkraineInvoiceData,
  AOPUkrainePaymentConfirmationData,
  AOPUkraineAcknowledgementData,
  AOPUkraineRequestData,
  DocumentsQRCodeData,
  DocumentsEmailData,
} from "../types/admissionOffice";
import { apiType } from "./apiType";

interface CreateTranscriptResponse {
  message: string;
  seria: string;
  pdf_path: string;
}

export const admissionOfficeRequests = {
  //------Malta------//
  createAdmissionDoc: async (data: AOPMaltaAdmissionData, signature: string) => {
    try {
      return await apiType.admissionDB.post(`/admission?template_name=${signature}`, data);
    } catch (error) {
      console.log("Это ошибка createAdmissionDoc:", error);
      return null;
    }
  },
  createAdmissionInvoiceDoc: async (data: AOPMaltaAdmissionData) => {
    try {
      return await apiType.admissionDB.post(`/admission-invoice`, data);
    } catch (error) {
      console.log("Это ошибка createAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createInvoiceDoc: async (data: AOPMaltaInvoiceData) => {
    try {
      return await apiType.admissionDB.post(`/invoice`, data);
    } catch (error) {
      console.log("Это ошибка createAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createAcknowledgementDoc: async (data: AOPMaltaAcknowledgementData) => {
    try {
      return await apiType.admissionDB.post(`/acknowledgement`, data);
    } catch (error) {
      console.log("Это ошибка createAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createPaymentConfirmationDoc: async (data: AOPMaltaPaymentConfirmationData) => {
    try {
      return await apiType.admissionDB.post(`/payment`, data);
    } catch (error) {
      console.log("Это ошибка createAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createStudentDoc: async (data: AOPMaltaStudentData) => {
    console.log(data);
    try {
      const formData = new FormData();

      formData.append("currentDate", data.currentDate);
      formData.append("fullName", data.fullName);
      formData.append("dateOfBirth", data.dateOfBirth);
      formData.append("nationality", data.nationality);
      formData.append("course", data.course);
      formData.append("userOffice", data.userOffice);
      formData.append("whose_doc", data.whose_doc);
      formData.append("title", data.title);
      formData.append("duration", data.duration);
      formData.append("mediumOfInstruction", data.mediumOfInstruction);
      formData.append("passportNumber", data.passportNumber);
      formData.append("academicYear", data.academicYear);
      formData.append("yearOfStudy", data.yearOfStudy);
      formData.append("yearStudyMode", data.yearStudyMode);
      formData.append("coursePrefix", data.coursePrefix);
      formData.append("bodyStudentLetter", JSON.stringify(data.bodyStudentLetter));
      formData.append("secondBodyStudentLetter", JSON.stringify(data.secondBodyStudentLetter));
      formData.append("secondPageDate", data.secondPageDate);
      formData.append("thirdBodyStudentLetter", JSON.stringify(data.thirdBodyStudentLetter));

      if (data.file) {
        formData.append("file", data.file);
      }

      const response = await apiType.admissionDB.post("/student-letter", formData);
      console.log("SUCCESS RESPONSE:", response);

      return response;
    } catch (error: any) {
      console.log("Это ошибка createStudentDoc:", error);
      return null;
    }
  },
  createCertificateDoc: async (data: AOPMaltaCertificateData) => {
    try {
      const response = await apiType.admissionDB.post(`/certificate`, data);
      console.log("SUCCESS RESPONSE:", response);
      return response;
    } catch (error) {
      console.log("Это ошибка createAdmissionCertificateDoc:", error);
      return null;
    }
  },
  createAuthorizationLetterteDoc: async (data: AOPMaltaCertificateData) => {
    try {
      const response = await apiType.admissionDB.post(`/authorization-letter`, data);
      console.log("SUCCESS RESPONSE:", response);
      return response;
    } catch (error) {
      console.log("Это ошибка createAdmissionCertificateDoc:", error);
      return null;
    }
  },
  //------Poland------//
  createPolandAdmissionDoc: async (data: AOPPolandAdmissionData, signature: string) => {
    try {
      return await apiType.admissionDB.post(`/pl/admission?template_name=${signature}`, data);
    } catch (error) {
      console.log("Это ошибка createPolandAdmissionDoc:", error);
      return null;
    }
  },
  createPolandAdmissionInvoiceDoc: async (data: AOPPolandAdmissionData) => {
    try {
      return await apiType.admissionDB.post(`/pl/admission-invoice`, data);
    } catch (error) {
      console.log("Это ошибка createPolandAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createPolandInvoiceDoc: async (data: AOPPolandInvoiceData) => {
    try {
      return await apiType.admissionDB.post(`/pl/invoice`, data);
    } catch (error) {
      console.log("Это ошибка createPolandInvoiceDoc:", error);
      return null;
    }
  },
  createPolandPaymentConfirmationDoc: async (data: AOPPolandPaymentConfirmationData) => {
    try {
      return await apiType.admissionDB.post(`/pl/payment`, data);
    } catch (error) {
      console.log("Это ошибка createPolandPaymentConfirmationDoc:", error);
      return null;
    }
  },
  createPolandAcknowledgementDoc: async (data: AOPPolandAcknowledgementData) => {
    try {
      return await apiType.admissionDB.post(`/pl/acknowledgement`, data);
    } catch (error) {
      console.log("Это ошибка createPolandAcknowledgementDoc:", error);
      return null;
    }
  },
  //------Ukraine------//
  createUkraineAdmissionDoc: async (data: AOPUkraineAdmissionData, signature: string) => {
    try {
      return await apiType.admissionDB.post(`/ua/admission?template_name=${signature}`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineAdmissionDoc:", error);
      return null;
    }
  },
  createUkraineAdmissionInvoiceDoc: async (data: AOPUkraineAdmissionData) => {
    try {
      return await apiType.admissionDB.post(`/ua/admission-invoice`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineAdmissionInvoiceDoc:", error);
      return null;
    }
  },
  createUkraineInvoiceDoc: async (data: AOPUkraineInvoiceData) => {
    try {
      return await apiType.admissionDB.post(`/ua/invoice`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineInvoiceDoc:", error);
      return null;
    }
  },
  createUkrainePaymentConfirmationDoc: async (data: AOPUkrainePaymentConfirmationData) => {
    try {
      return await apiType.admissionDB.post(`/ua/payment`, data);
    } catch (error) {
      console.log("Это ошибка createUkrainePaymentConfirmationDoc:", error);
      return null;
    }
  },
  createUkraineAcknowledgementDoc: async (data: AOPUkraineAcknowledgementData) => {
    try {
      return await apiType.admissionDB.post(`/ua/acknowledgement`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineAcknowledgementDoc:", error);
      return null;
    }
  },
  createUkraineRequestDoc: async (data: AOPUkraineRequestData) => {
    try {
      return await apiType.admissionDB.post(`/ua/pv`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineRequestDoc:", error);
      return null;
    }
  },
  //------Documents QR Code------//
  createDocumentsQRCode: async (data: DocumentsQRCodeData): Promise<CreateTranscriptResponse> => {
    const formData = new FormData();

    if (data.file) {
      formData.append("file", data.file);
    }

    const response = await apiType.admissionDB.post<CreateTranscriptResponse>("/transcript", formData, {
      params: {
        fullname: data.fullname,
        whose_doc: data.whose_doc,
        userOffice: data.userOffice,
        date: data.date,
        type: data.type,
      },
    });

    return response;
  },
  //------Documents Email------//
  createDocumentsEmailDoc: async (data: DocumentsEmailData) => {
    try {
      return await apiType.admissionDB.post(`/send-doc`, data);
    } catch (error) {
      console.log("Это ошибка createUkraineRequestDoc:", error);
      return null;
    }
  },
};
